module.exports = __webpack_public_path__ + "img/bad.1c7c5ca5.png";